<div class="hero-slider-area hero-slider-area-style-two">
    <div class="hero-slider-two" >
        <owl-carousel-o [options]="heroSlides">
            <ng-template carouselSlide *ngFor="let item of dataSourceSlide.data;">
                <!--data-aos="zoom-in" -->
                <div class="slider-item" style="{{ 'background-image: url(' + apiURL + item.photoPath1 + ');' }} ">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="hero-slider-content">

                                    <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                    </ng-template>
                                    <ng-template #other_ItemAr>
                                        <span>{{item.textAr1}}</span>
                                        <h1>{{item.textAr2}}</h1>
                                        <p>{{item.textAr3}}</p>
                                        <div class="hero-slider-btn">
                                            <a routerLink="/products" class="default-btn"><i class="ri-shopping-cart-line"></i> {{item.buttonTextAr}}</a>
                                        </div>
                                    </ng-template>
                                    <ng-template #other_ItemEn>
                                        <span>{{item.textEn1}}</span>
                                        <h1>{{item.textEn2}}</h1>
                                        <p>{{item.textEn3}}</p>
                                        <div class="hero-slider-btn">
                                            <a routerLink="/products" class="default-btn"><i class="ri-shopping-cart-line"></i> {{item.buttonTextEn}}</a>
                                        </div>
                                    </ng-template>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>




<!--<section class="slider-area-2">
    <div class="home-slider">
        <owl-carousel-o [options]="homeSlidesOptions">
            <ng-template carouselSlide *ngFor="let item of dataSourceSlide.data;">
                <div class="single-slider " style="{{ 'background-image: url(' + apiURL + item.photoPath1 + ');' }} ">
                    <div class="d-table">
                        <div class="d-table-cell">
                            <div class="container">
                                <div class="row align-items-center">
                                    <div class="col-lg-12 text-center">
                                        <div class="slider-content one">

                                            <ng-template *ngIf="SelectedLanguage == 'ar' ; then other_ItemAr  ; else other_ItemEn">
                                            </ng-template>
                                            <ng-template #other_ItemAr>
                                                <h1>{{item.textAr1}}</h1>
                                                <p>{{item.textAr2}}</p>
                                                <div class="slider-btn text-center">
                                                    <a routerLink="/contact" class="box-btn">{{item.buttonTextAr}}</a>
                                                </div>
                                            </ng-template>
                                            <ng-template #other_ItemEn>
                                                <h1>{{item.textEn1}}</h1>
                                                <p>{{item.textEn2}}</p>
                                                <div class="slider-btn text-center">
                                                    <a routerLink="/contact" class="box-btn">{{item.buttonTextEn}}</a>
                                                </div>
                                            </ng-template>


                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
  
        </owl-carousel-o>
    </div>
</section>-->


